<template>
	<div class="public-layout">
		<Navigation :frontEndUrl="frontEndUrl" :partnerUrl="partnerUrl"></Navigation>
		<!-- The old public-site stylesheet (assets/style-new.scss) is scoped to
			#signup-page and styles every link, span, paragraph and heading
			inside it. The header and footer (the marketing site's, 5 Oct 2026)
			sit outside it; a page built on the new look passes
			:legacy="false" so its content does too. -->
		<div :id="legacy ? 'signup-page' : null">
			<slot />
		</div>
		<Footer :frontEndUrl="frontEndUrl" :partnerUrl="partnerUrl"></Footer>
	</div>
</template>
<script>
import Navigation from "@/components/SignupNavigation";
import Footer from "@/components/SignupFooter";
import { IMPROVE_CONFIG } from '@/config.js';

export default {
	name: "LayoutBasic",
	components: {
		Navigation,
		Footer
	},
	props: {
		legacy: { type: Boolean, default: true }
	},
	data() {
		return {
			frontEndUrl: IMPROVE_CONFIG.FRONTEND_URL,
			partnerUrl: IMPROVE_CONFIG.PARTNER_URL
		}
	}
};
</script>
